import React from 'react';
import Cookies from 'js-cookie';
import confetti from 'canvas-confetti';
import styles from '../LiveResume.module.css';
import * as utils from '../../../utils/utils';
import Sidebar from '../../Sidebar/Sidebar';

const MAX_VOUCHERS = 2;

export default class LiveResumeVouchVerification extends React.Component {

	constructor(props) {
		super(props);

		this.state = {

			currentLiveResumeID: 0,

            peopleForVouch: [],
			selectedVouchUserIDs: [],
			vouchInviteEmails: ['', ''],
			isPeopleLoading: false,
			vouchSuccessText: '',

			isLoading: false,
			isEntityLoading: true,
			errorText: '',
			verificationErrorText: '',
		};
	}

	// componentDidMount() {
	// 	if (!utils.isLoggedIn()) {
	// 		window.location.href = '/signin';
	// 		return;
	// 	}
	// }

	// componentWillUnmount() {
	// }

	// getCleanVouchInviteEmails = () => {
	// 	const emails = Array.isArray(this.state.vouchInviteEmails) ? this.state.vouchInviteEmails : [];

	// 	return Array.from(new Set(
	// 		emails
	// 			.map((item) => String(item || '').trim().toLowerCase())
	// 			.filter((item) => item !== '')
	// 	));
	// };

	// getSelectedVouchPeople = () => {
	// 	const selectedSet = new Set(this.state.selectedVouchUserIDs || []);
	// 	const people = Array.isArray(this.state.peopleForVouch) ? this.state.peopleForVouch : [];

	// 	return people.filter((person) => selectedSet.has(person.userId));
	// };

	// getCurrentVouchCount = () => {
	// 	const selectedCount = this.getSelectedVouchPeople().length;
	// 	const inviteEmailCount = this.getCleanVouchInviteEmails().length;
	// 	return selectedCount + inviteEmailCount;
	// };

	// openVouchScreen = () => {
	// 	this.clearAllVerificationTimers();
	// 	this.setState({
	// 		currentScreen: this.screens.VouchFriends,
	// 		verificationMethod: 'vouch',
	// 		errorText: '',
	// 		verificationErrorText: '',
	// 		vouchSuccessText: '',
	// 	}, this.loadPeopleForVouch);
	// };

	// loadPeopleForVouch = async () => {
	// 	this.setState({
	// 		isPeopleLoading: true,
	// 		errorText: '',
	// 		verificationErrorText: '',
	// 	});

	// 	try {
	// 		const responseData = await utils.sendRequest('/userConnection/getPeopleForLiveResumeVerification', {});
	// 		const people = Array.isArray(responseData && responseData.people)
	// 			? responseData.people.map((person) => ({
	// 				userId: Number(person.userId),
	// 				firstName: person.firstName || '',
	// 				lastName: person.lastName || '',
	// 			})).filter((person) => Number.isInteger(person.userId) && person.userId > 0)
	// 			: [];

	// 		this.setState({
	// 			peopleForVouch: people,
	// 			isPeopleLoading: false,
	// 		});
	// 	} catch (error) {
	// 		this.setState({
	// 			isPeopleLoading: false,
	// 			errorText: error && error.message ? error.message : 'Could not load people for vouching right now.',
	// 		});
	// 	}
	// };

	// toggleVouchPerson = (userId) => {
	// 	const personID = Number(userId);
	// 	if (!Number.isInteger(personID) || personID <= 0) {
	// 		return;
	// 	}

	// 	const selectedSet = new Set(this.state.selectedVouchUserIDs || []);
	// 	const alreadySelected = selectedSet.has(personID);
	// 	const inviteCount = this.getCleanVouchInviteEmails().length;

	// 	if (!alreadySelected && selectedSet.size + inviteCount >= MAX_VOUCHERS) {
	// 		this.setState({
	// 			verificationErrorText: `You can only select or invite up to ${MAX_VOUCHERS} people total.`,
	// 			errorText: '',
	// 		});
	// 		return;
	// 	}

	// 	if (alreadySelected) {
	// 		selectedSet.delete(personID);
	// 	} else {
	// 		selectedSet.add(personID);
	// 	}

	// 	this.setState({
	// 		selectedVouchUserIDs: Array.from(selectedSet),
	// 		verificationErrorText: '',
	// 		errorText: '',
	// 		vouchSuccessText: '',
	// 	});
	// };

	// onVouchInviteEmailChange = (index, value) => {
	// 	const safeIndex = Number(index);
	// 	if (!Number.isInteger(safeIndex) || safeIndex < 0 || safeIndex > 1) {
	// 		return;
	// 	}

	// 	const nextInviteEmails = [...(this.state.vouchInviteEmails || ['', ''])];
	// 	nextInviteEmails[safeIndex] = value;

	// 	const nextCleanEmails = Array.from(new Set(
	// 		nextInviteEmails
	// 			.map((item) => String(item || '').trim().toLowerCase())
	// 			.filter((item) => item !== '')
	// 	));

	// 	const selectedCount = (this.state.selectedVouchUserIDs || []).length;
	// 	if (selectedCount + nextCleanEmails.length > MAX_VOUCHERS) {
	// 		this.setState({
	// 			verificationErrorText: `You can only select or invite up to ${MAX_VOUCHERS} people total.`,
	// 			errorText: '',
	// 		});
	// 		return;
	// 	}

	// 	this.setState({
	// 		vouchInviteEmails: nextInviteEmails,
	// 		verificationErrorText: '',
	// 		errorText: '',
	// 		vouchSuccessText: '',
	// 	});
	// };

	// submitVouchVerification = async () => {
	// 	const liveResumeID = Number(this.state.currentLiveResumeID);
	// 	if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
	// 		this.setState({
	// 			verificationErrorText: 'No live resume item is loaded. Please save again.',
	// 		});
	// 		return;
	// 	}

	// 	const selectedPeople = this.getSelectedVouchPeople();
	// 	const inviteEmails = this.getCleanVouchInviteEmails();
	// 	const totalVouchers = selectedPeople.length + inviteEmails.length;

	// 	if (totalVouchers !== MAX_VOUCHERS) {
	// 		this.setState({
	// 			verificationErrorText: `Please choose/invite exactly ${MAX_VOUCHERS} people before continuing.`,
	// 		});
	// 		return;
	// 	}

	// 	this.setState({
	// 		isLoading: true,
	// 		errorText: '',
	// 		verificationErrorText: '',
	// 		vouchSuccessText: '',
	// 	});

	// 	try {
	// 		await utils.sendRequest('/liveResume/vouchLiveResume', {
	// 			liveResumeID,
	// 			selectedPeople,
	// 			inviteEmails,
	// 		});

	// 		this.setState({
	// 			isLoading: false,
	// 			currentScreen: this.screens.Success,
	// 			verificationMethod: 'vouch',
	// 			vouchSuccessText: 'Vouch requests sent to 2 people.',
	// 		});
	// 	} catch (error) {
	// 		this.setState({
	// 			isLoading: false,
	// 			verificationErrorText: error && error.message ? error.message : 'Could not send vouch requests right now.',
	// 			errorText: error && error.message ? error.message : 'Could not send vouch requests right now.',
	// 		});
	// 	}
	// };

	// restartVerification = () => {
	// 	if (!this.state.currentLiveResumeID || !this.state.verificationQuestions.length) {
	// 		this.failVerification('No live resume is loaded for verification. Please save again.');
	// 		return;
	// 	}

	// 	this.setState({
	// 		errorText: '',
	// 		verificationErrorText: '',
	// 		verificationAnswersByQuestionID: {},
	// 		selectedAnswersByQuestionID: {},
	// 		learningIntentQuestionIDs: [],
	// 		verificationMisses: [],
	// 	}, this.startVerificationFlow);
	// };

	// goToDashboard = () => {
	// 	window.location.href = '/dashboard';
	// };

	// goBackToComposer = () => {
	// 	this.teardownVideoVerification();

	// 	this.clearAllVerificationTimers();
	// 	this.setState({
	// 		currentScreen: this.screens.EntityList,
	// 		isLoading: false,
	// 		errorText: '',
	// 		verificationErrorText: '',
	// 		verificationQuestions: [],
	// 		verificationAnswersByQuestionID: {},
	// 		selectedAnswersByQuestionID: {},
	// 		learningIntentQuestionIDs: [],
	// 		verificationMisses: [],
	// 		currentLiveResumeID: 0,
	// 		verificationMethod: '',
	// 		gainedStructure: null,
	// 		isStructureLoading: false,
	// 		structureLoadError: '',
	// 		peopleForVouch: [],
	// 		selectedVouchUserIDs: [],
	// 		vouchInviteEmails: ['', ''],
	// 		isPeopleLoading: false,
	// 		vouchSuccessText: '',
	// 		videoPermissionState: 'idle',
	// 		isVideoRecording: false,
	// 		videoSecondsLeft: MAX_VIDEO_SECONDS,
	// 		recordedVideoBlob: null,
	// 		recordedVideoURL: '',
	// 		recordedVideoMimeType: '',
	// 		videoSuccessText: '',
	// 		processingMessageIndex: 0,
	// 		currentQuestionIndex: 0,
	// 		selectedAnswerIndexes: [],
	// 		questionTimeLeft: 60,
	// 	});
	// };

	// goBackToVerificationChoice = () => {
	// 	if (this.state.recordedVideoURL) {
	// 		URL.revokeObjectURL(this.state.recordedVideoURL);
	// 	}

	// 	this.stopVideoRecording();
	// 	this.stopVideoStream();

	// 	this.clearAllVerificationTimers();
	// 	this.setState({
	// 		currentScreen: this.screens.VerificationChoice,
	// 		isLoading: false,
	// 		errorText: '',
	// 		verificationErrorText: '',
	// 		vouchSuccessText: '',
	// 		isVideoRecording: false,
	// 		videoSecondsLeft: MAX_VIDEO_SECONDS,
	// 		videoPermissionState: 'idle',
	// 		recordedVideoBlob: null,
	// 		recordedVideoURL: '',
	// 		recordedVideoMimeType: '',
	// 	});
	// };

	// renderScreenLayout = ({
	// 	screen,
	// 	title,
	// 	subtitle,
	// 	caption,
	// 	formTitle,
	// 	formText,
	// 	errorText,
	// 	children,
	// }) => {
	// 	return (
	// 		<>
	// 			<section className={styles.headerPanel}>
	// 				<h1 className={styles.title}>{title}</h1>
	// 				<p className={styles.subtitle}>{subtitle}</p>

	// 				<div className={styles.userRow}>
	// 					<span className={styles.userCaption}>{caption}</span>
	// 				</div>
	// 			</section>

	// 			<section className={styles.mainCardPanel}>
	// 				{this.renderDot(screen)}
	// 				<h2 className={styles.formTitle}>{formTitle}</h2>
	// 				<p className={styles.formText}>{formText}</p>

	// 				{children}

	// 				{errorText !== '' && <div className={styles.errorBox}>{errorText}</div>}
	// 			</section>
	// 		</>
	// 	);
	// };

	// renderVouchScreen = () => {
	// 	const {
	// 		peopleForVouch,
	// 		selectedVouchUserIDs,
	// 		vouchInviteEmails,
	// 		isPeopleLoading,
	// 		isLoading,
	// 		verificationErrorText,
	// 	} = this.state;

	// 	const selectedSet = new Set(selectedVouchUserIDs || []);
	// 	const currentVouchCount = this.getCurrentVouchCount();

	// 	return (
	// 		this.renderScreenLayout({
	// 			screen: this.screens.VouchFriends,
	// 			title: 'Capture your latest contribution while it is fresh.',
	// 			subtitle: 'Use social verification when peers can confirm quickly.',
	// 			caption: 'Pick exactly two vouchers using existing people and/or email invites.',
	// 			formTitle: 'Have Friends Vouch',
	// 			formText: `Choose and/or invite exactly ${MAX_VOUCHERS} people to vouch for this item.`,
	// 			errorText: this.state.errorText,
	// 			children: (
	// 				<div className={styles.vouchWrap}>
	// 					<div className={styles.verificationBanner}>
	// 						Choose and/or invite exactly {MAX_VOUCHERS} people to vouch for this live resume item.
	// 					</div>

	// 					<div className={styles.questionCard}>
	// 						<h3 className={styles.questionText}>People You Can Ask</h3>
	// 						{isPeopleLoading && <p className={styles.structureText}>Loading people...</p>}
	// 						{!isPeopleLoading && peopleForVouch.length === 0 && <p className={styles.structureText}>No existing people available right now. You can invite by email below.</p>}

	// 						{!isPeopleLoading && peopleForVouch.length > 0 && (
	// 							<div className={styles.peopleList}>
	// 								{peopleForVouch.map((person) => {
	// 									const isSelected = selectedSet.has(person.userId);
	// 									const disabled = !isSelected && currentVouchCount >= MAX_VOUCHERS;
	// 									const buttonClass = [styles.personButton, isSelected ? styles.personButtonSelected : ''].filter(Boolean).join(' ');

	// 									return (
	// 										<button
	// 											key={`person-${person.userId}`}
	// 											className={buttonClass}
	// 											onClick={() => this.toggleVouchPerson(person.userId)}
	// 											disabled={isLoading || disabled}
	// 										>
	// 											<span>{`${person.firstName} ${person.lastName}`.trim() || `User ${person.userId}`}</span>
	// 											{isSelected && <span className={styles.reviewSelectedTag}>Selected</span>}
	// 										</button>
	// 									);
	// 								})}
	// 							</div>
	// 						)}

	// 						<h3 className={styles.questionText}>Invite People By Email</h3>
	// 						<div className={styles.vouchInviteGrid}>
	// 							<input
	// 								type='text'
	// 								className={styles.selectInput}
	// 								placeholder='person1@example.com'
	// 								value={vouchInviteEmails[0] || ''}
	// 								onChange={(event) => this.onVouchInviteEmailChange(0, event.target.value)}
	// 								disabled={isLoading}
	// 							/>
	// 							<input
	// 								type='text'
	// 								className={styles.selectInput}
	// 								placeholder='person2@example.com'
	// 								value={vouchInviteEmails[1] || ''}
	// 								onChange={(event) => this.onVouchInviteEmailChange(1, event.target.value)}
	// 								disabled={isLoading}
	// 							/>
	// 						</div>

	// 						<div className={styles.vouchMetaRow}>
	// 							<div className={styles.verificationPill}>Selected total: {currentVouchCount} / {MAX_VOUCHERS}</div>
	// 						</div>

	// 						{verificationErrorText !== '' && <div className={styles.errorBox}>{verificationErrorText}</div>}

	// 						<div className={styles.failureActions}>
	// 							<button className={styles.primaryButton} onClick={this.submitVouchVerification} disabled={isLoading}>
	// 								{isLoading ? 'Sending...' : 'Send Vouch Requests'}
	// 							</button>
	// 							<button className={styles.secondaryButton} onClick={this.goBackToVerificationChoice} disabled={isLoading}>
	// 								Back
	// 							</button>
	// 						</div>
	// 					</div>
	// 				</div>
	// 			),
	// 		})
	// 	);
	// };

	// renderSuccessScreen = () => {
	// 	const successCopy = {
    //         icon: 'Requests Sent',
    //         title: 'Vouch Verification Started',
    //         text: vouchSuccessText || 'Your vouch requests are out for this live resume item.',
    //     };

	// 	return this.renderScreenLayout({
	// 		screen: this.screens.Success,
	// 		title: 'Capture your latest contribution while it is fresh.',
	// 		subtitle: 'Verification is complete for this step.',
	// 		caption: 'You can return to your dashboard or log another contribution.',
	// 		formTitle: 'Verification Complete',
	// 		formText: successCopy.text,
	// 		errorText: '',
	// 		children: (
	// 			<div className={styles.successWrap}>
	// 				<div className={styles.successIcon}>{successCopy.icon}</div>
	// 				<h3 className={styles.successTitle}>{successCopy.title}</h3>
	// 				<p className={styles.successText}>{successCopy.text}</p>
	// 				<div className={styles.failureActions}>
	// 					<button className={styles.primaryButton} onClick={this.goToDashboard}>
	// 						Back To Dashboard
	// 					</button>
	// 					<button className={styles.secondaryButton} onClick={this.goBackToComposer}>
	// 						Save Another Update
	// 					</button>
	// 				</div>
	// 			</div>
	// 		),
	// 	});
	// };

    render() {
        return null;
    };
}
